module.exports = __webpack_public_path__ + "img/PC_apple.e711f672.png";